import { useSelector } from 'react-redux';
import { State } from 'src/redux/types';
import { ServerRecord } from '../data/inventoryData';

export const useInfraMapList = (): [ServerRecord[], boolean?] => {
  const { data, loading } = useSelector(
    (state: State) => state.infraMap.list
  );
  return [data || [], loading];
};
